// src/App.js
import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthContext } from "./AuthContext/AuthContext";
import ProtectedRoute from "./AuthContext/ProtectedRoute";

import Login from "./Login/Login";
import Home from "./Home/Home";
import Users from "./Users/Users";
import Devices from "./Devices/Devices";

const App = () => {
  const { user } = useContext(AuthContext);

  return (
    <Router>
      <Routes>
        {/* Pública */}
        <Route path="/login" element={<Login />} />

        {/* Home */}
        <Route
          path="/home"
          element={user ? <Home /> : <Navigate to="/login" replace />}
        />

        {/* Usuarios */}
        <Route
          path="/users"
          element={
            <ProtectedRoute privilegeKey="users">
              <Users />
            </ProtectedRoute>
          }
        />

        {/* Dispositivos */}
        <Route
          path="/devices"
          element={
            <ProtectedRoute privilegeKey="devices">
              <Devices />
            </ProtectedRoute>
          }
        />

        {/* Catch-all */}
        <Route
          path="*"
          element={<Navigate to={user ? "/home" : "/login"} replace />}
        />
      </Routes>
    </Router>
  );
};

export default App;
